import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button, Checkbox, Dropdown, Form, Input, Modal, Table } from "semantic-ui-react";

import { SEASONS, getTyreSeasonIcon } from "./../../../../../../modules/Appointments/common";
import AppService from "./../../../../../../modules/Appointments/service";

const getTyreOnAnyPosition = carTyres => carTyres?.front_left_tyre || carTyres?.front_right_tyre || carTyres?.rear_left_tyre || carTyres?.rear_right_tyre;

export const getExistingCarTyre = car => getTyreOnAnyPosition(car?.on_car_tyres) || getTyreOnAnyPosition(car?.in_storage_tyres);

class DBBTyreSearch extends Component {
  constructor(props) {
    super(props);

    const existingTyre = getExistingCarTyre(props.car);

    this.state = {
      width: existingTyre?.width || "",
      height: existingTyre?.height || "",
      size: existingTyre?.size || "",
      season: null,
      manufacturer: "",
      brands: [],
      tyres: [],
      pickedTyre: null,
      isSearching: false,
      isFetchingBrands: false,
    };
  }

  componentDidMount() {
    this.getBrands();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open || !this.props.open || this.state.tyres.length) return;

    this.searchTyres();
  }

  getBrands = () => {
    this.setState({ isFetchingBrands: true }, () => {
      AppService.getTiresBrands()
        .then(result => this.setState({ brands: result?.data?.data?.brands || [], isFetchingBrands: false }))
        .catch(error => {
          this.setState({ isFetchingBrands: false });
          console.warn("Error getting tyre brands", error);
        });
    });
  };

  getBrandOptions = () => this.state.brands.map(brand => ({ key: brand, value: brand, text: brand }));

  getSeasonOptions = () => {
    const { t } = this.props;

    return [
      { key: SEASONS.ALL_SEASONS, value: SEASONS.ALL_SEASONS, text: t("all_seasons").message || "All seasons" },
      { key: SEASONS.WINTER, value: SEASONS.WINTER, text: t("winter").message || "Winter" },
      { key: SEASONS.SUMMER, value: SEASONS.SUMMER, text: t("summer").message || "Summer" },
    ];
  };

  handleSearch = event => {
    event.preventDefault();
    event.stopPropagation();

    this.searchTyres();
  };

  searchTyres = () => {
    const { width, height, size, season, manufacturer } = this.state;
    if (!width) return;

    this.setState({ isSearching: true, pickedTyre: null }, () => {
      AppService.searchTires({
        width: parseInt(width, 10),
        height: height ? parseInt(height, 10) : null,
        size: size ? parseInt(size, 10) : null,
        season,
        dealer_location_id: this.props.location?.id || 0,
        manufacturer: manufacturer || null,
      })
        .then(result => this.setState({ tyres: result?.data?.data?.tyres || [], isSearching: false }))
        .catch(error => {
          this.setState({ isSearching: false });
          console.warn("Error searching tyres", error);
        });
    });
  };

  handleClose = () => {
    this.setState({ pickedTyre: null });
    this.props.onClose();
  };

  handleConfirm = () => {
    const { pickedTyre } = this.state;
    if (!pickedTyre) return;

    this.props.onConfirm(pickedTyre);
    this.handleClose();
  };

  render() {
    const { open, t } = this.props;
    const { width, height, size, season, manufacturer, tyres, pickedTyre, isSearching, isFetchingBrands } = this.state;

    return (
      <Modal size="large" open={open} onClose={this.handleClose} closeOnDimmerClick={false} className="DBBTyreSearch">
        <Modal.Header>{t("add_tyre").message || "Add tyre"}</Modal.Header>
        <Modal.Content scrolling>
          <Form onSubmit={this.handleSearch}>
            <Form.Group>
              <Form.Field width={2} required>
                <label>{t("width").message || "Width"}</label>
                <Input value={width} required name="width" onChange={(_e, { value }) => this.setState({ width: value })} />
              </Form.Field>
              <Form.Field width={2} disabled={!width}>
                <label>{t("height").message || "Height"}</label>
                <Input value={height} name="height" onChange={(_e, { value }) => this.setState({ height: value })} />
              </Form.Field>
              <Form.Field width={2} disabled={!width || !height}>
                <label>{t("size").message || "Size"}</label>
                <Input value={size} name="size" onChange={(_e, { value }) => this.setState({ size: value })} />
              </Form.Field>
              <Form.Field width={6}>
                <label>{t("brand").message || "Brand"}</label>
                <Dropdown
                  selection
                  fluid
                  search
                  clearable
                  selectOnBlur={false}
                  loading={isFetchingBrands}
                  options={this.getBrandOptions()}
                  value={manufacturer}
                  onChange={(_e, { value }) => this.setState({ manufacturer: value || "" })}
                />
              </Form.Field>
              <Form.Field width={4}>
                <label>{t("season").message || "Season"}</label>
                <Dropdown
                  selection
                  fluid
                  clearable
                  selectOnBlur={false}
                  options={this.getSeasonOptions()}
                  value={season}
                  onChange={(_e, { value }) => this.setState({ season: value === "" ? null : value })}
                />
              </Form.Field>
              <Form.Field>
                <label>&nbsp;</label>
                <Button type="submit" className="search-button" disabled={!width || isSearching} loading={isSearching}>
                  {t("search").message || "Search"}
                </Button>
              </Form.Field>
            </Form.Group>
          </Form>

          {!isSearching && !tyres.length && <p className="no-results">{t("no_tyres_found").message || "No tyres found"}</p>}

          {!isSearching && !!tyres.length && (
            <Table className="DBBTyreSearch-table">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell />
                  <Table.HeaderCell>{t("description").message || "Description"}</Table.HeaderCell>
                  <Table.HeaderCell>{t("width").message || "Width"}</Table.HeaderCell>
                  <Table.HeaderCell>{t("height").message || "Height"}</Table.HeaderCell>
                  <Table.HeaderCell>{t("size").message || "Size"}</Table.HeaderCell>
                  <Table.HeaderCell>{t("speed").message || "Speed"}</Table.HeaderCell>
                  <Table.HeaderCell>{t("brand").message || "Brand"}</Table.HeaderCell>
                  <Table.HeaderCell />
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {tyres.map(tyre => (
                  <Table.Row key={tyre.id}>
                    <Table.Cell>{getTyreSeasonIcon(tyre.season)}</Table.Cell>
                    <Table.Cell>{tyre.description}</Table.Cell>
                    <Table.Cell>{tyre.width}</Table.Cell>
                    <Table.Cell>{tyre.height}</Table.Cell>
                    <Table.Cell>{tyre.size}</Table.Cell>
                    <Table.Cell>{tyre.speed}</Table.Cell>
                    <Table.Cell>{tyre.manufacturer}</Table.Cell>
                    <Table.Cell>
                      <Checkbox checked={tyre.id === pickedTyre?.id} onChange={() => this.setState({ pickedTyre: tyre })} />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="grey" onClick={this.handleClose}>
            {t("cancel").message || "Cancel"}
          </Button>
          <Button color="green" onClick={this.handleConfirm} disabled={!pickedTyre}>
            {t("confirm").message || "Confirm"}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation()(DBBTyreSearch);
